import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Connections from "./pages/Connections";
import ErrorsList from "./pages/ErrorsList";
import Settings from "./pages/Settings";
import Analytics from "./pages/Analytics";
import CostCalculator from "./pages/CostCalculator";
import Sentry from "./pages/integrations/Sentry";
import Datadog from "./pages/integrations/Datadog";
import NewRelic from "./pages/integrations/NewRelic";
import Zipy from "./pages/integrations/Zipy";
import ZipySetup from "./pages/integrations/ZipySetup";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import GitHub from "./pages/platforms/GitHub";
import GitLab from "./pages/platforms/GitLab";
import Bitbucket from "./pages/platforms/Bitbucket";
import Changelog from "./pages/Changelog";
import LovableIntegration from "./pages/platforms/Lovable";
import AnimationDemo from "./pages/AnimationDemo";
import BoltIntegration from "./pages/platforms/Bolt";
import { CommandPalette } from "./components/CommandPalette";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <CommandPalette />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/connections" element={<Connections />} />
          <Route path="/errors" element={<ErrorsList />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/cost-calculator" element={<CostCalculator />} />
          <Route path="/integrations/sentry" element={<Sentry />} />
          <Route path="/integrations/datadog" element={<Datadog />} />
          <Route path="/integrations/newrelic" element={<NewRelic />} />
          <Route path="/integrations/zipy" element={<Zipy />} />
          <Route path="/integrations/zipy-setup" element={<ZipySetup />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/platforms/github" element={<GitHub />} />
          <Route path="/platforms/gitlab" element={<GitLab />} />
          <Route path="/platforms/bitbucket" element={<Bitbucket />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/platforms/lovable" element={<LovableIntegration />} />
          <Route path="/platforms/bolt" element={<BoltIntegration />} />
          <Route path="/animation-demo" element={<AnimationDemo />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
